/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderFormData
 */
export interface ProviderFormData {
    /**
     * 
     * @type {string}
     * @memberof ProviderFormData
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProviderFormData
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderFormData
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderFormData
     */
    aggregatorProvider?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof ProviderFormData
     */
    providerIdentityCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderFormData
     */
    isMixAndMatchProvider?: boolean;
}

export function ProviderFormDataFromJSON(json: any): ProviderFormData {
    return ProviderFormDataFromJSONTyped(json, false);
}

export function ProviderFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'aggregatorProvider': !exists(json, 'aggregatorProvider') ? undefined : GuidIdAndLabelFromJSON(json['aggregatorProvider']),
        'providerIdentityCode': !exists(json, 'providerIdentityCode') ? undefined : json['providerIdentityCode'],
        'isMixAndMatchProvider': !exists(json, 'isMixAndMatchProvider') ? undefined : json['isMixAndMatchProvider'],
    };
}

export function ProviderFormDataToJSON(value?: ProviderFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'allowEdit': value.allowEdit,
        'label': value.label,
        'isActive': value.isActive,
        'disabled': value.disabled,
        'aggregatorProvider': GuidIdAndLabelToJSON(value.aggregatorProvider),
        'providerIdentityCode': value.providerIdentityCode,
        'isMixAndMatchProvider': value.isMixAndMatchProvider,
    };
}


